// extracted by mini-css-extract-plugin
export default {"newClassName":"style_newClassName__qSI8p","content":"style_content__-bXAR","tab":"style_tab__XOSQc","text":"style_text__VhYJW"};